export default "__VITE_ASSET__a300c5b0__"